// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isAppsBusinessUsageResult = objectOf({
  limits: objectOf({
    file_size: number,
    storage: number,
  }),
  plan: string,
  usage: objectOf({
    catalogs_storage: number,
  }),
});
